import React from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Avatar,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import OrederNotFound from "../../assets/OrederNotFound.png";
import dalchini_logo from "../../assets/dalchini_logo.png";
const OrderNotFound = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#e9e0d7",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          backgroundColor: "#f0d83c",
          height: 70,
          px: 2,
          display: "flex",
          alignItems: "center",
        }}
      >
       <Box
         src={dalchini_logo}         component="img"
         sx={{ height: 40, width: 40, mr: 2 }}  
            />
      </Box>

      {/* Card */}
      <Paper
        elevation={0}
        sx={{
          flex: 1,
          borderTopLeftRadius: 18,
          borderTopRightRadius: 18,
          mt: -1,
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#f7f7f7",
        }}
      >
        {/* Illustration */}
        <Box
          sx={{
           
            position: "relative",
            mt: 6,
            mb: 4,
          }}
        >
          <img
            src={OrederNotFound}
            alt="Order Not Found"
            width={250}
          />

        </Box>

        {/* Text */}
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: "#374151",
            mb: 1,
          }}
        >
          Order Not Found
        </Typography>

        <Typography
          align="center"
          sx={{
            color: "#6b7280",
            fontSize: 15,
            maxWidth: 260,
            lineHeight: 1.6,
          }}
        >
          We Couldn't Find Any Order
          <br />
          Linked To This Request
        </Typography>

        <Typography
          sx={{
            mt: 4,
            color: "#6b7280",
            fontSize: 15,
          }}
        >
          Please Try Again
        </Typography>

        {/* Bottom Buttons */}
        <Box
          sx={{
            mt: "auto",
            width: "100%",
            display: "flex",
            gap: 2,
            mb: 2,
          }}
        >
          <Button
            fullWidth
            variant="outlined"
            startIcon={<HomeIcon />}
            sx={{
              borderRadius: 2,
              py: 1.2,
              borderColor: "#00b67a",
              color: "#00b67a",
              fontWeight: 600,
              textTransform: "none",
            }}
          >
            Home
          </Button>

          <Button
            fullWidth
            variant="contained"
            startIcon={<HeadsetMicIcon />}
            sx={{
              borderRadius: 2,
              py: 1.2,
              backgroundColor: "#b7e5d3",
              color: "#00a86b",
              fontWeight: 600,
              textTransform: "none",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "#a8dcc8",
                boxShadow: "none",
              },
            }}
          >
            Help
          </Button>
        </Box>

        <Typography
          sx={{
            fontSize: 13,
            color: "#7c7c7c",
          }}
        >
          If The Issue Persists, Click Help.
        </Typography>
      </Paper>
    </Box>
  );
};

export default OrderNotFound;